import { createCustomFilterForEntity } from "@shared/backend/create-custom-filter-for-entity";
import {
  filterWithRelationsAndJson,
  type RelationalOrJsonEntityFilter,
} from "@shared/helpers/sql-relations";
import type { User } from "../user";
import { TimeReport } from "./";

const createCustomFilter = createCustomFilterForEntity<TimeReport>();

export class TimeReportFilters {
  /**
   * # 🌟✨ HyperFilter – The Ultimate Filtering Powerhouse!
   * ### 🤝 Filter through complex relations effortlessly
   * ### 📦 Directly filter JSON fields (no backend work required!)
   * ### 🚀 Transforms your filter into a single, optimized DB query
   * ### 🔒 Engineered for maximum SQL injection protection
   *
   * ---
   * ### Example:
   * ```ts
   * myEntityRepo.find({
   *  where: MyEntity.hyperFilter({ ... })
   * })
   * ```
   *
   * ---
   * Built by Natan Salmon
   */
  static hyperFilter = createCustomFilter<
    RelationalOrJsonEntityFilter<TimeReport>
  >((filters) => {
    return filterWithRelationsAndJson(TimeReport)(filters);
  });

  static isThisUser = createCustomFilter<{ user: string | User }>(
    ({ user }) => {
      return this.hyperFilter({
        association: {
          $is: {
            userId: typeof user === "string" ? user : user?.id,
          },
        },
      });
    },
  );

  static isUserNameMatchValue = createCustomFilter<{ searchValue: string }>(
    ({ searchValue }) => {
      return this.hyperFilter({
        association: {
          $is: {
            user: {
              $is: {
                name: {
                  $contains: searchValue,
                },
              },
            },
          },
        },
      });
    },
  );
}
